import { analyticsService, AnalyticsEvent, AnalyticsTypes } from '@/shared/analytics/export';

let deferredPrompt: any;
window.addEventListener('beforeinstallprompt', (e: Event) => {
  e.preventDefault();
  deferredPrompt = e;
});

function install(): void {
  deferredPrompt && deferredPrompt.prompt();
}

function canInstall(): boolean {
  return !!deferredPrompt;
}

// Caller supplies the subject getter so this service doesn't depend on auth.
function registerInstallAnalytics(getSubject: () => unknown) {
  window.addEventListener('appinstalled', () => {
    analyticsService.recordAnalyticsEvent(AnalyticsEvent.PWA_INSTALLED, {
      subject: getSubject(),
      object: { type: AnalyticsTypes.PWA_INSTALLATION },
      session: { id: sessionStorage.getItem('sessionId') },
    });
  });
}

// eslint-disable-next-line
export default {
  install,
  canInstall,
  registerInstallAnalytics,
};
